import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Form, Button, Card, CardHeader, CardBody, CardFooter, Row, Col } from 'reactstrap';
import { Field, reduxForm } from 'redux-form';

import { renderField } from 'core/utils/form';
import { required, matchPwd, minLength } from 'core/utils/validations';
import CardTitle from 'components/ui/CardTitle/CardTitle';

const propTypes = {
  onSubmit: PropTypes.func.isRequired,
  initialValues: PropTypes.object.isRequired,
};
const minLength8 = minLength(8);

class UserForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      password: null,
    };
  }

  renderTitle = (initialValues) =>
    initialValues.id ? 'Edit user' : 'Add user';

  renderActiveField = ({ initialValues, error, renderField }) => {
    if (!initialValues.id) { return null; }

    return (
      <Field
        name="active"
        type="switch"
        label="Active"
        error={error}
        component={renderField}
      />
    );
  }

  renderResendActivationEmailField = ({ initialValues, error, renderField }) => {
    if (!initialValues.id) { return null; }
    if (this.state.password) { return null; }

    return (
      <Field
        name="resend_activation_email"
        type="switch"
        label="Resend Activation Email"
        error={error}
        component={renderField}
      />
    );
  }

  renderPasswordFields = ({ initialValues, error, renderField }) => {
    if (!initialValues.id) { return null; }
    const confirmationValidations = [minLength8, matchPwd];
    if (this.state.password) { confirmationValidations.push(required); }

    return (
      <Row>
        <Col xs="12" md="6">
          <Field
            name="password"
            type="password"
            label="Password"
            error={error}
            component={renderField}
            onChange={(e) => this.setState({ password: e.target.value })}
            validate={[minLength8]}
          />
        </Col>

        <Col xs="12" md="6">
          <Field
            name="password_confirmation"
            type="password"
            label="Password Confirmation"
            error={error}
            component={renderField}
            validate={confirmationValidations}
          />
        </Col>
      </Row>
    );
  }

  render() {
    const { error, handleSubmit, invalid, submitting, initialValues } = this.props

    return (
      <Form onSubmit={handleSubmit}>
        <Card className="pageCard">
          <CardHeader>
            <CardTitle>{this.renderTitle(initialValues)}</CardTitle>
          </CardHeader>
          <CardBody className="padded">
            <Row>
              <Col xs="12" md="6">
                <Field
                  name="first_name"
                  type="text"
                  label="First Name"
                  error={error}
                  component={renderField}
                  validate={[required]}
                />
              </Col>
              <Col xs="12" md="6">
                <Field
                  name="last_name"
                  type="text"
                  label="Last Name"
                  error={error}
                  component={renderField}
                  validate={[required]}
                />
              </Col>
            </Row>

            <Field
              name="email"
              type="email"
              label="Email"
              error={error}
              component={renderField}
              validate={[required]}
            />

            {this.renderPasswordFields({ initialValues, error, renderField })}

            <Field
              name="dep_cert_number"
              type="text"
              label="State license number"
              error={error}
              component={renderField}
            />
            {this.renderActiveField({ initialValues, error, renderField })}
            {this.renderResendActivationEmailField({ initialValues, error, renderField })}
          </CardBody>
          <CardFooter>
            <Button
              color="primary"
              disabled={invalid || submitting}
            >
              Save
            </Button>
          </CardFooter>
        </Card>
      </Form>
    )
  }
}

UserForm.propTypes = propTypes

UserForm = reduxForm({
  form: 'user'
})(UserForm)

export default UserForm



// WEBPACK FOOTER //
// ./src/features/user/UserForm.js